import { productImageStyles } from "@guestsupply/Overrides/Components/ProductImage";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productImageStyles.linkWrappingImage = {
    css: css`
        width: 100%;
        position: relative;
        &&& {
            height: auto;
            flex-direction: column;
        }
    `,
};

productImageStyles.img = {
    css: css`
        height: auto;
        width: 100%;
        max-width: 100%;
        max-height: 100%;
        border-radius: 4px;
    `,
};
productImageStyles.textBadge = {
    css: css`
        width: 100%;
    `,
};
productImageStyles.badgeWrapper = {
    css: css`
        ${({ isGridView }: any) =>
            isGridView
                ? " position: absolute; bottom: 8px; left: 8px;"
                : " position: static; width: 100%; margin-top: 8px; display: block;"}
    `,
};
